import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'

import * as agentsTab from './agents-tab'
import * as generalTab from './general-tab'
import * as pagesTab from './pages-tab'
import * as scenariosTab from './scenarios-tab'
import * as usersTab from './users-tab'

@ngCore.Component({
  imports: [
    pagesTab.Component,
    ds.tabs.floatingHorizontal.Component,
    ds.tabs.tab.Directive,
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    generalTab.Component,
    usersTab.Component,
    agentsTab.Component,
    scenariosTab.Component,
  ],
  selector: 'atn-admin-app-page',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.tenants.Collection} */
  public readonly tenantsEc = ngCore.inject(state.admin.tenants.Collection)

  /** @see {@link state.admin.zones.Collection} */
  public readonly zonesEc = ngCore.inject(state.admin.zones.Collection)

  /** @see {@link state.admin.apps.Collection} */
  public readonly appsEc = ngCore.inject(state.admin.apps.Collection)

  /** @see {@link state.admin.contexts.Feature} */
  private readonly _contextsFeature = ngCore.inject(
    state.admin.contexts.Feature,
  )

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** Name of selected application for edit*/
  public readonly appNameSg = ngCore.computed(
    (
      app = this.appsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => app?.name,
  )

  /** Indicates whether selected application supports scenarios */
  public readonly supportsScenariosSg = ngCore.computed(
    (
      app = this.appsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => app?.supportsScenarios ?? false,
  )

  /** Alias of selected application for edit*/
  private readonly _appAliasSg = ngCore.computed(
    (
      app = this.appsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => app?.alias,
  )

  /**
   * Breadcrumbs displayed in page header
   */
  public readonly breadcrumbsSg = ngCore.computed(
    (
      zone = this.zonesEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
      tenant = this.tenantsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => {
      const breadcrumbs: ds.layout.page.child.header.models.Breadcrumb[] = []

      breadcrumbs.push({
        name: 'Tenants',
        url: this._contextsFeature.selectors.getUrlForTenants().asSignal(),
      })

      if (tenant) {
        const tenantUrl = this._contextsFeature.selectors
          .getUrlForTenant(tenant)
          .asSignal()
        if (tenantUrl) {
          breadcrumbs.push({
            name: tenant.name ?? tenant.alias ?? '',
            url: tenantUrl,
          })
        }
      }

      if (zone) {
        const zoneUrl = this._contextsFeature.selectors
          .getUrlForZone(zone)
          .asSignal()
        if (zoneUrl) {
          breadcrumbs.push({
            name: zone.name ?? zone.alias ?? '',
            url: zoneUrl,
          })
        }
      }

      breadcrumbs.push({ name: this.appNameSg() ?? this._appAliasSg() ?? '' })

      return breadcrumbs
    },
  )

  /** Whether the Users tab is available for the current admin user */
  public readonly canManageUsersSg = ngCore.computed(
    (
      context = this._contextsFeature.selectors.activeEntityContext.asSignal(),
      currentUser = this._meFeature.selectors.currentUser.asSignal(),
    ) =>
      state.admin.userAssignment.models.User.canManageUsersForContext(
        currentUser,
        context,
      ),
  )
}
